import { gql } from '../../__generated__/gql'

export const COMMUNITY_POSTS_QUERY = gql(`
  query communityPostsQuery(
    $page: Int
    $perPage: Int
    $orderBy: SortCommunityPostsEnum
    $categoryId: Int
  ) {
    communityPosts(
      page: $page
      perPage: $perPage
      orderBy: $orderBy
      categoryId: $categoryId
    ) {
      ...communityPostFields
      imageUrl
      author {
        id
        firstName
        lastName
        email
        picture
        roles
        communityProfile {
          id
          role
          postsCount
          allVotesCount
          online
          levelInfo {
            level
            progress
          }
        }
      }
      lastReply {
        id
        author {
          id
          firstName
          lastName
        }
        createdAt
      }
    }
  }
`)
